// extracted by mini-css-extract-plugin
export default {"button":"BasketButton-module__button___-KvV2","icon":"BasketButton-module__icon___Q-E2B","number":"BasketButton-module__number___Laf4f"};